<template>
  <FormKit
    :id="formId"
    :value="filters"
    type="form"
    :actions="false"
    form-class="space-y-4"
    @input="triggerSubmit"
    @submit="submit"
  >
    <div>
      <h3 class="mb-2 font-medium">
        Locatie
      </h3>
      <div class="flex gap-x-2">
        <FormKit
          outer-class="basis-2/3 !mb-2"
          placeholder="Plaats of postcode"
          name="city"
          type="text"
          validation-label="Plaats of postcode"
          :delay="500"
        />
        <FormKit
          outer-class="basis-1/3 !mb-2"
          inner-class="relative"
          input-class="pr-8"
          placeholder="10"
          name="radius"
          type="text"
          validation="number|min:10"
          value="20"
          validation-label="Straal"
          :validation-messages="{min: radiusValidationMessage}"
          :delay="500"
        >
          <template #suffix>
            <div class="absolute inset-y-0 right-1.5 flex items-center text-sm">
              KM
            </div>
          </template>
        </FormKit>
      </div>
    </div>
    <div>
      <h3 class="mb-2 font-medium">
        Zoekterm
      </h3>
      <FormKit
        placeholder="Bijv. hovenier"
        name="search"
        type="text"
        :delay="500"
      />
    </div>
    <div>
      <h3 class="mb-2 font-medium">
        Beroepsgroep
      </h3>
      <FormKit
        name="sector"
        type="checkbox"
        :options="sectors"
      />
    </div>
    <div>
      <h3 class="mb-2 font-medium">
        Uren per week
      </h3>
      <FormKit
        name="hours"
        type="checkbox"
        :options="['0 - 20', '20 - 32', '32 - 40']"
      />
    </div>
    <div class="flex justify-between lg:justify-start">
      <FormKit
        type="submit"
        outer-class="lg:hidden"
        label="Resultaten"
        @click="closeModal"
      />
      <button
        class="mt-4 pb-4 underline"
        @click="resetForm"
      >
        Reset filters
      </button>
    </div>
  </FormKit>
</template>

<script setup lang="ts">
import {onMounted} from 'vue';
import {reset, submitForm} from '@formkit/core';
import type {VacancyFilters} from '~/graphql/graphql';
import type {SectorFilter} from '~/types';

const props = defineProps<{
  filters: VacancyFilters;
  sectors: SectorFilter[];
  formId: string;
}>();

const radiusValidationMessage = ({name, args}) => (`${name} moet minimaal "${args[0]}" kilometer zijn.`);

// eslint-disable-next-line func-call-spacing
const emit = defineEmits<{
  (e: 'update-filters', data: VacancyFilters): void
  (e: 'reset-filters'): void
  (e: 'close-modal'): void
}>();

const mounted = ref(false);
onMounted(() => {
  mounted.value = true;
});

const triggerSubmit = () => {
  if (mounted.value) {
    submitForm(props.formId);
  }
};
const submit = function (data) {
  emit('update-filters', data);
};
const resetForm = () => {
  emit('reset-filters');
  reset(props.formId);
};
const closeModal = () => {
  emit('close-modal');
};
</script>
